import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { UX2, constants } from '@wsb/guac-widget-core';
import formFields from '../formFields';
import LabeledInput from '../LabeledInput';
import dataAids from '../dataAids';

class MlsSearchForm extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      minPrice: '',
      maxPrice: '',
      minBed: '',
      minBath: '',
      propertyType: '',
      city: '',
      fetchError: false,
      propertyTypes: [],
      cities: [],
      idxUrl: '',
      sortBy: ''
    };
  }

  // eslint-disable-next-line camelcase, id-length
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.apiKey !== this.props.apiKey) {
      this.fetchFieldData(nextProps.apiKey, nextProps.hasApiKey);
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchFieldData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchFieldData(apiKey = this.props.apiKey, hasApiKey = this.props.hasApiKey) {
    if (!hasApiKey) {
      return;
    }
    const { env, websiteId, pageId, widgetId, registeredDomainName, domainName } = this.props;

    const envConfig = {
      local: 'dev-godaddy.com',
      development: 'dev-godaddy.com',
      test: 'test-secureserver.net',
      production: 'secureserver.net'
    };

    const params = [];
    if (apiKey) {
      params.push(`apiKey=${apiKey}`);
    }
    if (registeredDomainName !== domainName) {
      params.push('registration=true');
    }
    const queryString = params.length ? `?${params.join('&')}` : '';
    const url = `https://mls.apps-api.${envConfig[env]}/v1/data/${websiteId}/${pageId}/${widgetId}${queryString}`;

    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.send();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          this._isMounted &&
            this.setState({
              propertyTypes: response.propertyTypes,
              cities: response.cities,
              idxUrl: response.systemLinks[0].url,
              fetchError: false
            });
        } else {
          this._isMounted &&
            this.setState({
              fetchError: true
            });
        }
      }
    };
  }

  onSubmit(e) {
    e.preventDefault();
    const url = `${this.state.idxUrl}?${this.generateQueryString()}`;
    window.open(url, '_self');
  }

  generateQueryString() {
    return formFields.reduce((query, field) => {
      let fieldValuePair = '';
      const value = this.state[field.name];
      let separator;
      if (value) {
        separator = query !== '' && '&';
        fieldValuePair = `${field.fieldName}=${value}`;
      }

      return `${query}${separator || ''}${fieldValuePair}`;
    }, '');
  }

  renderFields(fields) {
    return fields.map((field, index) => {
      const { label, name, type, size, lastField, order } = field;

      if (type === 'DROP_DOWN') {
        return this.renderDropdown(field);
      }
      return (
        <LabeledInput
          labelText={ label }
          onChange={ this.setValue.bind(this, name) }
          name={ label }
          data-aid={ label }
          value={ this.state[name] }
          key={ index }
          type={ type }
          size={ size }
          lastField={ lastField }
          order={ order }
        />
      );
    });
  }

  renderDropdown(field) {
    const {
      name,
      optionData, // can be an array or reference to a key in the state
      optionId,
      optionName,
      label,
      defaultAllText,
      type,
      size,
      lastField,
      order
    } = field;

    let options = [];
    const optionDataArr = Array.isArray(optionData) ? optionData : this.state[optionData];

    if (optionDataArr.length > 0) {
      options = optionDataArr.map((val, index) => {
        const option = (
          <option key={ index + 1 } value={ val[optionId] }>
            { val[optionName] }
          </option>
        );
        if (index === 0) {
          const defaultOption = defaultAllText ? (
            <option key={ 0 } value=''>
              { defaultAllText }
            </option>
          ) : (
            <option key={ 0 } disabled hidden value=''></option>
          );
          return [defaultOption, option];
        }
        return option;
      });
    }

    return (
      <LabeledInput
        labelText={ label }
        value={ this.state[name] }
        onChange={ this.setValue.bind(this, name) }
        children={ options }
        type={ type }
        size={ size }
        lastField={ lastField }
        order={ order }
      />
    );
  }

  renderSubmitBtn() {
    const { renderMode } = this.props;
    const disabled = renderMode !== constants.renderModes.PUBLISH || !this.state.idxUrl;
    const styles = {
      block: {
        'width': '31.3%',
        'display': 'flex',
        'alignItems': 'center',
        '@xs-only': { width: '100%' },
        '@sm-only': { width: '100%' }
      }
    };
    return (
      <UX2.Element.Block style={ styles.block }>
        <UX2.Element.Button.Primary
          tag='button'
          type='submit'
          value='Submit'
          disabled={ disabled }
          state={ disabled ? 'disabled' : 'default' }
          id='mls-submit'
          fullWidth
        >
          <div>Search Now</div>
        </UX2.Element.Button.Primary>
      </UX2.Element.Block>
    );
  }

  setValue(property, event) {
    this.setState({ [property]: event.target.value });
  }

  render() {
    const styles = {
      headingStyles: {
        marginBottom: 'medium'
      },
      form: {
        'width': '100%',
        'paddingVertical': 'medium',
        '@sm': {
          paddingHorizontal: 'medium'
        },
        '@md': {
          paddingVertical: 'xlarge',
          paddingHorizontal: 'xlarge'
        }
      },
      fieldsContainer: {
        display: 'flex',
        flexWrap: 'wrap'
      }
    };

    return (
      <UX2.Group.Form
        category='neutral'
        tag='form'
        onSubmit={ this.onSubmit }
        style={ styles.form }
        { ...this.props }
      >
        <UX2.Element.Heading.Minor
          data-aid={ dataAids.MLS_SEARCH_FORM_TITLE_RND }
          group='Content'
          style={ styles.headingStyles }
          children='Search Listings'
        />
        <div style={ styles.fieldsContainer }>
          { this.renderFields(formFields) }
          { this.renderSubmitBtn() }
        </div>
      </UX2.Group.Form>
    );
  }
}

MlsSearchForm.propTypes = {
  websiteId: PropTypes.string,
  pageId: PropTypes.string,
  widgetId: PropTypes.string,
  env: PropTypes.string,
  apiKey: PropTypes.string,
  domainName: PropTypes.string,
  registeredDomainName: PropTypes.string,
  renderMode: PropTypes.string,
  hasApiKey: PropTypes.bool
};

export default MlsSearchForm;
